const environments = {
    development: "development",
    staging: "staging",
    production: "production",
};
const currentEnvironment = process.env.REACT_APP_ENVIRONMENT;
function isDevelopment() {
    return currentEnvironment === environments.development;
}
function isStaging() {
    return currentEnvironment === environments.staging;
}
function isProduction() {
    return currentEnvironment === environments.production;
}
export const environment = {
    currentEnvironment,
    environments,
    isDevelopment,
    isStaging,
    isProduction,
};
